import React from "react";
import { Modal } from "react-bootstrap";
import NeedsAnalysis from "./NeedAnalysis";

export default function NeedsCalculator(props) {

  return (
    <Modal show={props.fields.modalNeedsCalculatorIsOpen} className="need-analysis-model" scrollable={true} onHide={() => { props.fields.setModalNeedsCalculatorIsOpen(false) }} backdrop="true" size="lg">
      <Modal.Body>
        <NeedsAnalysis fields={props.fields} isPrequote={props.isPrequote} isCustomTerm={props.isCustomTerm}/>
      </Modal.Body>
    </Modal>
  );
}


// WEBPACK FOOTER //
// ./src/components/Tools/NeedsAnalysis/NeedsCalculator.js